@if (todoEntryModel()) {
  <div
    appTodoEntryInteraction
    [todoEntryModel]="todoEntryModel()"
    class="{{ TodoEntryWrapperCSSClass }} k-py-1.5"
    [id]="todoEntryModel().id"
    #todoEntryWrapper
    [attr.data-sorted-index]="
      todoEntryModel().fixInterval ? parallelIndex() : todoEntryModel().order
    "
    [attr.data-pos-y]="0"
    [attr.data-gap]="0"
    [style.top.px]="todoEntryTop()"
    [style.width]="todoEntryWidth() !== null ? todoEntryWidth() + 'px' : 'auto'"
    [style.margin-block]="parallelIndex() === 0 ? 'auto' : '0'"
    [style.--todo-color]="todoEntryModel().color"
    [class.is-completed]="todoEntryModel().completed"
    [class.fix-interval]="todoEntryModel().fixInterval"
    [class.starts-before-planner-start]="startsBeforePlannerStart()"
    [class.ends-after-planner-end]="endsAfterPlannerEnd()"
  >
    <div class="todo-entry-content k-w-full k-d-inline-flex k-pl-4 k-pr-2 k-pos-relative">
      <div class="content-wrapper k-flex-1 k-overflow-hidden">
        <div class="name-wrapper">
          <div
            (click)="complete($event)"
            role="checkbox"
            class="completed-check k-align-self-center k-d-inline-flex k-justify-content-center k-align-items-center k-p-2 k-mr-1.5"
          >
            @if (todoEntryModel().completed) {
              <fa-icon [icon]="faCheckSolid" size="2xs"></fa-icon>
            } @else {
              <fa-icon class="turquoise" [icon]="faCheckRegular" size="2xs"></fa-icon>
            }
          </div>
          <span class="name k-font-weight-semibold">
            {{ todoEntryModel().name }}
          </span>
        </div>
        @if (hideDetails()) {
          <div class="meta k-d-flex k-justify-content-between">
            <div class="priority">
              <fa-icon class="icon k-pos-relative white k-mr-1" [icon]="faAnglesUp"></fa-icon>
              <span class="k-text-uppercase">{{ priorityText() }}</span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
